import {DeepLinkActionBase} from "../deep-link-action-base";

export class ControlCenterDeeplinkAction extends DeepLinkActionBase {
  async execute() {

    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin({}, this.descriptor.marketingParams);
    }

    if (!this.services.safezone.isEnabled) {
      return Promise.reject('Control center is disabled for logged in user!');
    }

    this.services.safezone.openFullSafezone();
  }
}
